import GeoApi from '../api/destinations';
import { buildIdSlugPath } from '../utils/slugify';
import { ROUTE_KEYS } from '../constants';

const obtenerDatoUrl = (key) =>
  window.location.search[key] || new URLSearchParams(window.location.search).get(key);

const obtenerValoresPorMoneda = (precioObj, currencyCode = 'ars') => {
  const currencyCodeLowerCase = currencyCode.toLowerCase();
  const valoresDefault = {
    valores: [
      precioObj.precioNeto,
      precioObj.impuestos,
      precioObj.impuestoPais,
      precioObj.irgAfip,
      precioObj.iva,
    ],
    moneda: 'ARS',
  };

  switch (currencyCodeLowerCase) {
    case 'usd':
      if (precioObj.precioNetoDolares) {
        return {
          valores: [precioObj.precioNetoDolares, precioObj.impuestosDolares, precioObj.ivaDolares],
          moneda: 'USD',
        };
      }
      break;
    case 'ars':
      if (precioObj.precioNeto) {
        return valoresDefault;
      }
      break;
    default:
      return valoresDefault;
  }
  return valoresDefault;
};

export default {
  priceValidator(currencyExchange, prices, appCurrencyCode) {
    if (prices.moneda && prices.moneda.toLowerCase() === appCurrencyCode.toLowerCase()) {
      return prices;
    }

    return (
      currencyExchange.find(
        (priceInCurrency) => priceInCurrency.moneda.toLowerCase() === appCurrencyCode.toLowerCase()
      ) || prices
    );
  },

  priceTotal(price, pax) {
    const totalPrice = price.precioNeto + price.impuestos + price.impuestoPais + price.iva;
    const finalPrice = totalPrice / pax;
    return finalPrice;
  },

  precioTotal(precioObj, currencyCode = 'ARS', conMoneda = false) {
    const { valores, moneda } = obtenerValoresPorMoneda(precioObj, currencyCode);
    const importe = valores.reduce((acc, act) => (act ? acc + act : acc), 0);

    return conMoneda ? { importe, moneda } : valores;
  },
  precioUnitario(precioObj, pasajeros = 1, currencyCode = 'ARS', conMoneda = false) {
    const { valores, moneda } = obtenerValoresPorMoneda(precioObj, currencyCode);
    const valorUnitario = this.valorUnitario(valores, pasajeros);

    return conMoneda ? { valorUnitario, moneda } : valorUnitario;
  },
  valorUnitario(valores = [], partes = 1) {
    let resultado;
    if (!partes) {
      return null;
    }
    const suma = valores.reduce((acc, act) => {
      if (act) {
        acc = acc + act;
      }
      return acc;
    }, 0);

    try {
      resultado = suma / partes;
    } catch (error) {
      resultado = null;
    }
    return resultado;
  },
  obtenerDistribucion(distribucion = false) {
    let distribucionCodigo = obtenerDatoUrl('h');

    if (!distribucionCodigo && distribucion) {
      distribucionCodigo = distribucion;
    }

    if (!distribucionCodigo) {
      distribucionCodigo = window.location.pathname.split('/')[6];
    }

    const distribucionLista = distribucionCodigo.split('!');
    const listaHabitaciones = [];
    for (let indice = 0; indice < distribucionLista.length; indice++) {
      const habitaciones = { adultos: '', menores: '' };
      const edadesMenores = [];
      const pasajeros = distribucionLista[indice].split('-');
      const cantidadAdultos = pasajeros[0];
      for (let pasajero = 1; pasajero < pasajeros.length; pasajero++) {
        edadesMenores.push(pasajeros[pasajero]);
      }
      habitaciones.adultos = cantidadAdultos;
      habitaciones.menores = edadesMenores;
      listaHabitaciones.push(habitaciones);
    }
    return listaHabitaciones;
  },
  obtenerCantidadPasajeros(listaHabitacion) {
    let cantidadPasajeros = 0;

    for (let indice = 0; indice < listaHabitacion.length; indice++) {
      const menores =
        listaHabitacion[indice].menores.length > 0 ? listaHabitacion[indice].menores.length : 0;
      cantidadPasajeros += parseInt(listaHabitacion[indice].adultos, 10) + menores;
    }
    return cantidadPasajeros;
  },

  obtenerCantidadPasajerosAdultos(listaHabitacion) {
    let cantidadPasajeros = 0;

    for (let indice = 0; indice < listaHabitacion.length; indice++) {
      cantidadPasajeros += parseInt(listaHabitacion[indice].adultos, 10);
    }
    return cantidadPasajeros;
  },
  obtenerCantidadPasajerosMenores(listaHabitacion) {
    let cantidadPasajeros = 0;

    for (let indice = 0; indice < listaHabitacion.length; indice++) {
      const menores =
        listaHabitacion[indice].menores.length > 0 ? listaHabitacion[indice].menores.length : 0;
      cantidadPasajeros += menores;
    }
    return cantidadPasajeros;
  },

  obtenerDatoUrl(query) {
    obtenerDatoUrl(query);
  },

  obtenerCiudadPorCodigo(code) {
    return GeoApi.getCityByCode(code);
  },
  numberToMoney(number) {
    return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
  },
  numberFixedToMoney(number = 0, fixed = 2) {
    const numberFixed = number.toFixed(fixed).replace('.', ',');
    return this.numberToMoney(numberFixed);
  },
  length(item) {
    if (item.length !== undefined) {
      return item.length;
    }
    return Object.keys(item).length;
  },
  checkCountryTax(packageCountryTax) {
    return packageCountryTax != null && packageCountryTax !== 0;
  },
  getLocationInformation() {
    if (typeof window === 'undefined') {
      return global.expressLocation;
    }
    return window.location;
  },
  filterText(string) {
    if (typeof string !== 'string') return string;

    return string
      .replace(/\([^)]*\)/g, '')
      .replace(/[-]/g, ' ')
      .replace(/[%]/g, ' ')
      .replace(/\s\s/g, ' ')
      .replace(/[-][-][-]/g, '-')
      .replace(/[-][-]/g, '-')
      .replace(/[-]/g, ' ')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/amp;/g, '')
      .replace(/(&amp;)/g, '')
      .replace(/[)]/g, '')
      .replace(/[&]/g, 'and')
      .replace('amp', '')
      .replace(/[;]/g, '')
      .replace(/<br>|<br >|<\/br>/g, ' ')
      .replace('(5A)', '')
      .replace('(3A)', '')
      .replace('(6A)', '')
      .replace(/[*]/g, '')
      .replace('1A', '');
  },
  finalPrice({ countryTaxes, iva, netPrice, taxes }) {
    return countryTaxes + iva + netPrice + taxes;
  },
  imgUrlValidator(imgUrl) {
    const imgDefault = 'https://res.mundigea.com.ar/img/recursos/paquete.jpg';

    if (imgUrl == null || imgUrl === '') return imgDefault;

    const img = imgUrl
      .split(';')[0]
      .replace(/\s/g, '%20')
      .replace('https://www.ola.com.ar//www.ola.com.ar', 'https://www.ola.com.ar')
      .replace('travelit/image/upload', 'travelit/image/upload/c_scale,q_50,c_fill,q_auto:low');

    return img || ImagenDefault;
  },
  imgUrlSliderValidator(imgUrl) {
    const imgDefault = 'https://res.mundigea.com.ar/img/recursos/paquete.jpg';

    if (imgUrl == null || imgUrl === '') return imgDefault;

    const img = imgUrl
      .split(';')[0]
      .replace(/\s/g, '%20')
      .replace('https://www.ola.com.ar//www.ola.com.ar', 'https://www.ola.com.ar')
      .replace('travelit/image/upload', 'travelit/image/upload/c_scale,q_50,c_fill,q_auto:low');

    return img || ImagenDefault;
  },
  imgUrlMediumValidator(imgUrl) {
    const imgDefault = 'https://res.mundigea.com.ar/img/recursos/paquete.jpg';

    if (imgUrl == null || imgUrl === '') return imgDefault;

    const img = imgUrl
      .split(';')[0]
      .replace(/\s/g, '%20')
      .replace('https://www.ola.com.ar//www.ola.com.ar', 'https://www.ola.com.ar')
      .replace(
        'travelit/image/upload',
        'travelit/image/upload/c_scale,q_50,h_600,w_281,c_fill,q_auto:low'
      );

    return img || ImagenDefault;
  },
  addBasePath(base, originalUrl) {
    return originalUrl && originalUrl.startsWith('/') ? `${base}${originalUrl}` : originalUrl;
  },
  urlForNavBarItem(navbarItemObj) {
    if (navbarItemObj.tipoSeccion.nombre === 'URL') {
      return navbarItemObj.contenido;
    }
    return buildIdSlugPath(ROUTE_KEYS.CUSTOM_SECTION, navbarItemObj.id, navbarItemObj.descripcion);
  },
};
